<template>
  <div>
    <!-- toasts message -->
            <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
    <!-- /toasts message -->
    <v-progress-circular v-if="Loader" :size="70" :width="7" color="teal" indeterminate></v-progress-circular>
    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->
<v-form v-model="valid" ref="form" lazy-validation>
      <v-card-text class="pb-0">
        <v-container grid-list-md>
          <v-layout wrap>
           <v-flex xs12 sm6 md4>								
						<v-text-field label="Participant Name" v-model="formSchema.participant_name" :rules="[v => !!v || 'Name is required']"></v-text-field>
					 </v-flex>
           <v-flex xs12 sm6 md4>								
						<v-text-field label="Designation" v-model="formSchema.designation" :rules="[v => !!v || 'Designation is required']"></v-text-field>
					 </v-flex>
           <v-flex xs12 sm6 md4>								
						<v-text-field label="Department / Division" v-model="formSchema.division_department" ></v-text-field>
					 </v-flex>
           <v-flex xs12 sm6 md4>								
						<v-text-field label="Organization" v-model="formSchema.institute" :rules="[v => !!v || 'Organization is required']"></v-text-field>
					 </v-flex>
           <v-flex xs12 sm6 md4>								
						<v-text-field label="Mobile Number" v-model="formSchema.phone" :rules="[rules.phoneNumber]"></v-text-field>
					 </v-flex>
           <v-flex xs12 sm6 md4>								
						<v-text-field label="Email" v-model="formSchema.email" :rules="[rules.email]"></v-text-field>
					 </v-flex>
        
          </v-layout>
           
        </v-container>
      </v-card-text>
    </v-form>
     <v-card-actions>
      <v-spacer></v-spacer>
       <v-btn color="error" @click="previous">
        <v-icon>arrow_back_ios</v-icon>Previous
      </v-btn>
     
      <v-btn color="primary" @click="submitOperationActivities">
        {{addUpdateBtn}} 
        <v-icon>save</v-icon>
      </v-btn>
      <v-btn color="warning" @click="close">
        Reset
        <v-icon>refresh</v-icon>
      </v-btn>
       <v-btn color="error" @click="nextStep">
        Next
        <v-icon>arrow_forward_ios</v-icon>
      </v-btn>
    </v-card-actions>

    <v-card class="mb-3 mt-3 table-responsive" color="lighten-1">
      <v-data-table
      class="elevation-4"
      :headers="headers"
      :items="items"
    >
     <template slot="items" slot-scope="props">
			            <td class="text-xs-left">{{ (props.index)+1 }}</td>
			            <td class="text-xs-left">{{ props.item.participant_name }}</td>
			            <td class="text-xs-left">{{ props.item.designation }}</td>
			            <td class="text-xs-left">{{ props.item.division_department }}</td>
			            <td class="text-xs-left">{{ props.item.institute }}</td>
			            <td class="text-xs-left">{{ props.item.phone }}</td>
			            <td class="text-xs-left">{{ props.item.email }}</td>
			            
			            <td class="justify-center layout px-0">
			                <v-btn icon class="mx-0"  @click="editItem(props.index, props.item)">
			                    <v-icon color="teal">edit</v-icon>
			                </v-btn>
			                <v-btn icon class="mx-0"  @click="deleteItem(props.index, props.item.id)">
			                    <v-icon color="pink">delete</v-icon>
			                </v-btn>
			            </td>
			        </template> 
		 

		         <template slot="no-data" class="error">
       <div align="center"> No Data Found</div>
    </template>
    </v-data-table>
      
    </v-card>
    
    <v-card-actions>
      <v-spacer></v-spacer>
     
    </v-card-actions>
  </div>
</template>

<script>
let commonService = require("../../../../services/common.service");
export default {
  props:['get_training_id'],

  data() {
    return {
      valid: true,
      Loader: false,
      items:[],
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ],
      headers: [
      {
        text:'SL'
      },
      {
        text: "Participant Name",
        align: "left",
        sortable: true,
        value: "participant_name"
      },
      { text: "Designation", align: "left", sortable: true, value: "designation" },
      { text: "Department/Devision", align: "left", sortable: true, value: "division_department" },
      { text: "Organization",sortable: true, value: "institute" },
      { text: "Mobile", value: "phone" },
      { text: "E-mail", value: "email" },
      { text: "Action", value: "" }
    ],
      devMt_partner_id: "",
      operation_act_id: "",
      e1: 0,
      credit: "",
      training: [],
      rules: {
        decimalOnly: [
          v => !!v || "Field is required",
          v => /^\d+(\.\d)?\d*$/.test(v) || "Enter number only"
        ],
        email: (v) => {
        // const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        // return pattern.test(value) || "Enter valid e-mail.";
        if (v && v.length > 0) {
        return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) ||
          "E-mail must be valid";
        } else {
           return true
        }
       },
       phoneNumber: (v) => {
          // const pattern = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{5})$/;
          // return pattern.test(value) || "Enter valid phone no.";
          if (v && v.length > 0) {
            return (
              /(\+)?^[+0-9\(\)_.-]*$/.test(v) ||
              "Phone no. must be valid"
            );
          } else {
            return true;
          }
        },
      },
      delete_id: "",
      row_index: "",
      dialog2: false,
      snackbar: false,
      color: "success",
      mode: "",
      timeout: 3000,
      left: "left",
      message: "",
      SnackbarVal: {
      snackbar: false,
      color: "success",
      message: "",
    },
      devMtPartnerList: [],
      creditMasterList: [],
      formSchema: {
          id: 0,
          training_id: sessionStorage.getItem("training_info"),
          participant_name: "",
          designation: "",
          division_department: "",
          institute: "",
          phone: "",
          email: ""
        },

      dataList: [],
      trainingID:''
    };
  },
  computed:{
    addUpdateBtn() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    },
    getTrainingData(){
       commonService.getAllData('training_info').then(res => {  
                    this.training = res.data;
                    this.loading = false;
              });   
     },
  },
  watch:{
    get_training_id(){
         this.formSchema.training_id = this.get_training_id
    }
  },
  methods: {
    getDataFromApi(){
        commonService.getAllDataById(this.formSchema.training_id,'training_participant_info').then(res => {  
                    this.items = res.data;
                    this.loading = false;
              });                
    },
    loadData(opId) {
     
    },

    submitOperationActivities() {
      if (this.$refs.form.validate()) {
        let formSchema = this.formSchema;
        this.submitForm();
      }
    },

    submitForm() {
      let root = this;
      this.Loader = true;
      let formSchema = this.formSchema
       if ( formSchema.id > 0 )
          {            
              commonService.updateFormData(formSchema, 'training_participant_info').then(res => {							
							if(res.status == 1){
                 this.SnackbarVal.color = 'success';
                 this.SnackbarVal.message = res.message;
                 this.SnackbarVal.snackbar = true;
                 this.getDataFromApi()
                setTimeout(function() {
                  root.nextStep();
                }, 3000); 
							}else{
                this.message = res.message
                this.snackbar = true
              }
						});
            
          }
          else
          {            
            commonService.insertFormData(formSchema, 'training_participant_info').then(res => {	
             				
							if(res.status == 1){
                this.SnackbarVal.color = 'success';
                 this.SnackbarVal.message = res.message;
                 this.SnackbarVal.snackbar = true;
                this.getDataFromApi()
                setTimeout(function() {
                  root.nextStep();
                }, 3000);  
							}else{
                this.message = res.message
                this.snackbar = true
              }
						});
            
          }
    },

    nextStep() {
     
      this.Loader = false; 
      this.$refs.form.reset()
      this.formSchema.id = 0
      this.getDataFromApi()
      this.$emit("emitForm3", 3);
      
    },

    previous() {
      this.$refs.form.reset()
      this.$emit("emitForm3", 1);
    },

    editItem(index, item) {
      this.row_index = index;
      this.formSchema = item;
  
      window.scrollTo({
        top: 0,
        left: 100,
        behavior: "smooth"
      });
    },

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.dialog2 = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "training_participant_info").then(res => {
        if (res.status == 1) {
          this.items.splice(row_index, 1);
          //this.getDataFromApi();
        }
        this.SnackbarVal.color = 'success';
        this.SnackbarVal.message = res.message;
        this.SnackbarVal.snackbar = true;
        this.confirmModel = false;
        this.dialog2 = false;
      });
    },

    close: function() {
        if (this.formSchema.id > 0) {
        close(0);
      } else {
        this.$refs.form.reset();
      }
    }
  },
  mounted(){
    this.getDataFromApi()
    // this.getTrainingData()
    console.log(this.formSchema.training_id)
  }
};
</script>

<style scoped>
.tableTd {
  display: inline-block;
}
.v-progress-circular {
  margin: 5rem;
  position: absolute !important;
  left: 37%;
}
</style>


// WEBPACK FOOTER //
// src/components/training/training_information/step_forms/participantInfoForm.vue